import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "formulario",
  class: "bg-gray-100 py-12"
}
const _hoisted_2 = { class: "container mx-auto px-4 max-w-5xl" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-gray-800 mb-0 text-2xl text-center pt-5" }, " ACREDITARME ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-gray-800 mb-4 text-2xl text-center pt-2 pb-5" }, " Por favor complete el formulario en su totalidad ", -1)
const _hoisted_5 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_6 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Nombre", -1)
const _hoisted_8 = { class: "text-sm text-red-500 p-error" }
const _hoisted_9 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Apellido", -1)
const _hoisted_11 = { class: "text-sm text-red-500 p-error" }
const _hoisted_12 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_13 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "DNI / Pasaporte", -1)
const _hoisted_15 = { class: "text-sm text-red-500 p-error" }
const _hoisted_16 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_17 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Empresa", -1)
const _hoisted_19 = { class: "text-sm text-red-500 p-error" }
const _hoisted_20 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Cargo", -1)
const _hoisted_22 = { class: "text-sm text-red-500 p-error" }
const _hoisted_23 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_24 = { class: "w-full px-2 md:w-8/12" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Dirección", -1)
const _hoisted_26 = { class: "text-sm text-red-500 p-error" }
const _hoisted_27 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Código postal", -1)
const _hoisted_29 = { class: "text-sm text-red-500 p-error" }
const _hoisted_30 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_31 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Localidad", -1)
const _hoisted_33 = { class: "text-sm text-red-500 p-error" }
const _hoisted_34 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Provincia", -1)
const _hoisted_36 = { class: "text-sm text-red-500 p-error" }
const _hoisted_37 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_38 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "País", -1)
const _hoisted_40 = { class: "w-full px-2 md:w-2/12" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Código de país", -1)
const _hoisted_42 = { class: "w-full px-2 md:w-2/12" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Código de área", -1)
const _hoisted_44 = { class: "text-sm text-red-500 p-error" }
const _hoisted_45 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Teléfono fijo", -1)
const _hoisted_47 = { class: "text-sm text-red-500 p-error" }
const _hoisted_48 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_49 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "País", -1)
const _hoisted_51 = { class: "w-full px-2 md:w-2/12" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Código de país", -1)
const _hoisted_53 = { class: "w-full px-2 md:w-2/12" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Código de área", -1)
const _hoisted_55 = { class: "text-sm text-red-500 p-error" }
const _hoisted_56 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Teléfono celular", -1)
const _hoisted_58 = { class: "text-sm text-red-500 p-error" }
const _hoisted_59 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_60 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Mail", -1)
const _hoisted_62 = { class: "text-sm text-red-500 p-error" }
const _hoisted_63 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Web Site", -1)
const _hoisted_65 = { class: "text-sm text-red-500 p-error" }
const _hoisted_66 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_67 = { class: "w-full px-2 md:w-1/4" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Prefesión / Actividad", -1)
const _hoisted_69 = { class: "text-sm text-red-500 p-error" }
const _hoisted_70 = { class: "w-full px-2 md:w-1/4" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Otra profesión", -1)
const _hoisted_72 = { class: "text-sm text-red-500 p-error" }
const _hoisted_73 = { class: "w-full px-2 md:w-1/4" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Rubro de su empresa", -1)
const _hoisted_75 = { class: "text-sm text-red-500 p-error" }
const _hoisted_76 = { class: "w-full px-2 md:w-1/4" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Otro rubro", -1)
const _hoisted_78 = { class: "text-sm text-red-500 p-error" }
const _hoisted_79 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_80 = { class: "w-full px-2 md:w-1/4" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "¿Cómo se enteró?", -1)
const _hoisted_82 = { class: "text-sm text-red-500 p-error" }
const _hoisted_83 = { class: "w-full px-2 md:w-1/4" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Otro medio", -1)
const _hoisted_85 = { class: "text-sm text-red-500 p-error" }
const _hoisted_86 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Rol en la compra", -1)
const _hoisted_88 = { class: "text-sm text-red-500 p-error" }
const _hoisted_89 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_90 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Seleccione su rango etario", -1)
const _hoisted_92 = { class: "text-sm text-red-500 p-error" }
const _hoisted_93 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Seleccione el objetivo de su visita", -1)
const _hoisted_95 = { class: "text-sm text-red-500 p-error" }
const _hoisted_96 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_97 = { class: "w-full px-2" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Seleccione sus rubros de interés", -1)
const _hoisted_99 = { class: "text-sm text-red-500 p-error" }
const _hoisted_100 = { class: "flex flex-wrap py-2 mt-3" }
const _hoisted_101 = ["disabled"]
const _hoisted_102 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_103 = { class: "pi pi-check mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSection = _resolveComponent("HeaderSection")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSection),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.onSubmit,
        "validation-schema": _ctx.schema,
        class: "space-y-4 text-gray-700"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_Field, {
                  name: "nombre",
                  modelValue: _ctx.formData.nombre,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.nombre) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Nombre",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_8, [
                      _createVNode(_component_ErrorMessage, { name: "nombre" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_Field, {
                  name: "apellido",
                  modelValue: _ctx.formData.apellido,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.apellido) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Apellido",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_11, [
                      _createVNode(_component_ErrorMessage, { name: "apellido" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_Field, {
                  name: "documento",
                  modelValue: _ctx.formData.documento,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.documento) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "numeric",
                      placeholder: "Documento / Pasaporte",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_15, [
                      _createVNode(_component_ErrorMessage, { name: "documento" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_Field, {
                  name: "empresa",
                  modelValue: _ctx.formData.empresa,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.empresa) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Empresa",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_19, [
                      _createVNode(_component_ErrorMessage, { name: "empresa" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createVNode(_component_Field, {
                  name: "cargo",
                  modelValue: _ctx.formData.cargo,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.cargo) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Cargo",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_22, [
                      _createVNode(_component_ErrorMessage, { name: "cargo" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode(_component_Field, {
                  name: "direccion",
                  modelValue: _ctx.formData.direccion,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.direccion) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Dirección",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_26, [
                      _createVNode(_component_ErrorMessage, { name: "direccion" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_component_Field, {
                  name: "codigoPostal",
                  modelValue: _ctx.formData.codigoPostal,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.codigoPostal) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Cargo",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_29, [
                      _createVNode(_component_ErrorMessage, { name: "codigoPostal" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createVNode(_component_Field, {
                  name: "localidad",
                  modelValue: _ctx.formData.localidad,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.localidad) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Localidad",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_33, [
                      _createVNode(_component_ErrorMessage, { name: "localidad" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createVNode(_component_Field, {
                  name: "provincia",
                  modelValue: _ctx.formData.provincia,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.provincia) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Cargo",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_36, [
                      _createVNode(_component_ErrorMessage, { name: "provincia" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.selectedCountryFijo,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedCountryFijo) = $event)),
                  options: _ctx.paises,
                  optionLabel: "descripcion",
                  placeholder: "Seleccione un país",
                  class: "w-full md:w-14rem p-inputtext-sm"
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                (_ctx.selectedCountryFijo !== null)
                  ? (_openBlock(), _createBlock(_component_InputText, {
                      key: 0,
                      type: "text",
                      modelValue: _ctx.selectedCountryFijo.id,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedCountryFijo.id) = $event)),
                      class: "w-full p-inputtext-sm p-3",
                      readonly: ""
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createVNode(_component_Field, {
                  name: "codigoAreaFijo",
                  modelValue: _ctx.formData.codigoAreaFijo,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.codigoAreaFijo) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_44, [
                      _createVNode(_component_ErrorMessage, { name: "codigoAreaFijo" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createVNode(_component_Field, {
                  name: "telefonoFijo",
                  modelValue: _ctx.formData.telefonoFijo,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.telefonoFijo) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_47, [
                      _createVNode(_component_ErrorMessage, { name: "telefonoFijo" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _createVNode(_component_Dropdown, {
                  modelValue: _ctx.selectedCountryCel,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedCountryCel) = $event)),
                  options: _ctx.paises,
                  optionLabel: "descripcion",
                  placeholder: "Seleccione un país",
                  class: "w-full md:w-14rem p-inputtext-sm"
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _hoisted_52,
                (_ctx.selectedCountryCel !== null)
                  ? (_openBlock(), _createBlock(_component_InputText, {
                      key: 0,
                      type: "text",
                      modelValue: _ctx.selectedCountryCel.id,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selectedCountryCel.id) = $event)),
                      class: "w-full p-inputtext-sm p-3",
                      readonly: ""
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                _createVNode(_component_Field, {
                  name: "codigoAreaCel",
                  modelValue: _ctx.formData.codigoAreaCel,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.codigoAreaCel) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_55, [
                      _createVNode(_component_ErrorMessage, { name: "codigoAreaCel" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _hoisted_57,
                _createVNode(_component_Field, {
                  name: "telefonoCelular",
                  modelValue: _ctx.formData.telefonoCelular,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.telefonoCelular) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_58, [
                      _createVNode(_component_ErrorMessage, { name: "telefonoCelular" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _hoisted_61,
                _createVNode(_component_Field, {
                  name: "mail",
                  modelValue: _ctx.formData.mail,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.mail) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Mail",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_62, [
                      _createVNode(_component_ErrorMessage, { name: "mail" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_63, [
                _hoisted_64,
                _createVNode(_component_Field, {
                  name: "webSite",
                  modelValue: _ctx.formData.webSite,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.webSite) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Web site",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_65, [
                      _createVNode(_component_ErrorMessage, { name: "webSite" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("div", _hoisted_67, [
                _hoisted_68,
                _createVNode(_component_Field, {
                  name: "profesion",
                  modelValue: _ctx.formData.profesion,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.profesion) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value , errors}) => [
                    _createVNode(_component_Dropdown, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione su profesión",
                      class: _normalizeClass(["w-full p-inputtext-sm", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && value !== undefined, 'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]),
                      options: _ctx.profesiones,
                      optionLabel: "descripcion"
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_69, [
                      _createVNode(_component_ErrorMessage, { name: "profesion" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_70, [
                _hoisted_71,
                _createVNode(_component_Field, {
                  name: "profesionOtra",
                  modelValue: _ctx.formData.profesionOtra,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.profesionOtra) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      readonly: _ctx.formData.profesion?.id !== 'Otro',
                      type: "text",
                      placeholder: "Otra profesión",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["readonly", "class"]),
                    _createElementVNode("span", _hoisted_72, [
                      _createVNode(_component_ErrorMessage, { name: "profesionOtra" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_73, [
                _hoisted_74,
                _createVNode(_component_Field, {
                  name: "rubro",
                  modelValue: _ctx.formData.rubro,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.rubro) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                    _createVNode(_component_Dropdown, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione el rubro",
                      class: _normalizeClass(["w-full p-inputtext-sm", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0  && value !== undefined, 'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]),
                      options: _ctx.rubros,
                      optionLabel: "descripcion"
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_75, [
                      _createVNode(_component_ErrorMessage, { name: "rubro" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_76, [
                _hoisted_77,
                _createVNode(_component_Field, {
                  name: "rubroOtro",
                  modelValue: _ctx.formData.rubroOtro,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.rubroOtro) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      readonly: _ctx.formData.rubro?.id !== 'Otro',
                      type: "text",
                      placeholder: "Otro rubro",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["readonly", "class"]),
                    _createElementVNode("span", _hoisted_78, [
                      _createVNode(_component_ErrorMessage, { name: "rubroOtro" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_79, [
              _createElementVNode("div", _hoisted_80, [
                _hoisted_81,
                _createVNode(_component_Field, {
                  name: "medio",
                  modelValue: _ctx.formData.medio,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.medio) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                    _createVNode(_component_Dropdown, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione el medio",
                      class: _normalizeClass(["w-full p-inputtext-sm", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0  && value !== undefined, 'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]),
                      options: _ctx.medios,
                      optionLabel: "descripcion"
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_82, [
                      _createVNode(_component_ErrorMessage, { name: "medio" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_83, [
                _hoisted_84,
                _createVNode(_component_Field, {
                  name: "medioOtro",
                  modelValue: _ctx.formData.medioOtro,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.medioOtro) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      readonly: _ctx.formData.medio?.id !== 'Otro',
                      type: "text",
                      placeholder: "Otro medio",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["readonly", "class"]),
                    _createElementVNode("span", _hoisted_85, [
                      _createVNode(_component_ErrorMessage, { name: "medioOtro" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_86, [
                _hoisted_87,
                _createVNode(_component_Field, {
                  name: "rolCompra",
                  modelValue: _ctx.formData.rolCompra,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.rolCompra) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                    _createVNode(_component_Dropdown, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione su rol",
                      class: _normalizeClass(["w-full p-inputtext-sm", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && value !== undefined, 'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]),
                      options: _ctx.rolesCompra,
                      optionLabel: "descripcion"
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_88, [
                      _createVNode(_component_ErrorMessage, { name: "rolCompra" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("div", _hoisted_90, [
                _hoisted_91,
                _createVNode(_component_Field, {
                  name: "rangoEtario",
                  modelValue: _ctx.formData.rangoEtario,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.rangoEtario) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                    _createVNode(_component_Dropdown, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione su rango etario",
                      class: _normalizeClass(["w-full p-inputtext-sm", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && value !== undefined, 'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]),
                      options: _ctx.rangosEtarios,
                      optionLabel: "descripcion"
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_92, [
                      _createVNode(_component_ErrorMessage, { name: "rangoEtario" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_93, [
                _hoisted_94,
                _createVNode(_component_Field, {
                  name: "objetivo",
                  modelValue: _ctx.formData.objetivo,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formData.objetivo) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                    _createVNode(_component_Dropdown, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione el objetivo de su visita",
                      class: _normalizeClass(["w-full p-inputtext-sm", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && value !== undefined, 'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]),
                      options: _ctx.objetivos,
                      optionLabel: "descripcion"
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_95, [
                      _createVNode(_component_ErrorMessage, { name: "objetivo" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("div", _hoisted_97, [
                _hoisted_98,
                _createVNode(_component_Field, {
                  name: "rubrosInteres",
                  modelValue: _ctx.formData.rubrosInteres,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formData.rubrosInteres) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                    _createVNode(_component_MultiSelect, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      options: _ctx.rubrosInteresList,
                      optionLabel: "descripcion",
                      placeholder: "Seleccione los canales de interés",
                      showToggleAll: false,
                      class: _normalizeClass(["w-full p-inputtext-sm text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && value !== undefined, 'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}])
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_99, [
                      _createVNode(_component_ErrorMessage, { name: "rubrosInteres" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_100, [
              _createElementVNode("button", {
                type: "submit",
                label: "REGISTRARME",
                class: "mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded",
                disabled: _ctx.isSubmitting
              }, [
                _withDirectives(_createElementVNode("i", _hoisted_102, null, 512), [
                  [_vShow, _ctx.isSubmitting]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_103, null, 512), [
                  [_vShow, !_ctx.isSubmitting]
                ]),
                _createTextVNode("REGISTRARME ")
              ], 8, _hoisted_101)
            ])
          ]),
          _createVNode(_component_BlockUI, {
            blocked: _ctx.isSubmitting,
            fullScreen: ""
          }, null, 8, ["blocked"])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ], 64))
}